module.exports = __webpack_public_path__ + "img/131.d025c96d.jpg";